import { useRef } from "react";

export default function useVideoHover() {
    const videoRefs = useRef([]);

    const play = (i) => videoRefs.current[i]?.play().catch(() => { });
    const stop = (i) => {
        const v = videoRefs.current[i];
        if (!v) return;
        v.pause();
        v.currentTime = 0;
    };

    return { videoRefs, play, stop };
}
